import { render } from "./EmptyOkrList.vue?vue&type=template&id=520ca701&scoped=true"
import script from "./EmptyOkrList.vue?vue&type=script&lang=js"
export * from "./EmptyOkrList.vue?vue&type=script&lang=js"

import "./EmptyOkrList.vue?vue&type=style&index=0&id=520ca701&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520ca701"]])

export default __exports__